import React, { useState, useEffect } from 'react'
import {
  StaticImage,
  GatsbyImage,
  getImage,
  IGatsbyImageData,
} from 'gatsby-plugin-image'
import {
  Head,
  ValuesTabs,
  Differential,
  Testimonials,
  Modal,
} from '@components'
import cn from 'classnames'
import { translatePath } from '../translations'
import { Link } from 'gatsby'
import * as st from '@assets/styl/about.module.styl'
import * as st2 from '@assets/styl/modal.module.styl'
import { graphql, useStaticQuery } from 'gatsby'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation, Pagination } from 'swiper/modules'

import play from '@assets/svg/play.svg'

import { useLanguage } from '../hooks'

export default () => {
  const { t } = useLanguage()
  const [isMobile, setIsMobile] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1199)

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const data = useStaticQuery(graphql`
    query {
      allDimasWays {
        nodes {
          id
          image
          title
          description
          url
          external
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 439, height: 282, placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  const dimasWays = data.allDimasWays.nodes

  return (
    <>
      <Head
        pathname={translatePath('/jeito-dimas/')}
        basePath="/jeito-dimas/"
        title={t('JeitoDimas.titlePage')}
        description={t('JeitoDimas.descriptionPage')}
      />
      <section className={cn(st.hero, 'heroScroll')}>
        <h1>{t('JeitoDimas.title.1')}</h1>
        <div className={st.bg}>
          <StaticImage
            src="../assets/img/mulher-costas.jpg"
            alt=""
            className={st.desktop}
            loading="lazy"
          />
          <StaticImage
            src="../assets/img/mulher-costas-mobile.jpg"
            alt=""
            className={st.mobile}
            loading="lazy"
          />
        </div>
      </section>
      <section className={st.history}>
        <div>
          <h3>{t('JeitoDimas.ourStory')}</h3>
          <p>{t('JeitoDimas.aSearch')}</p>
          <StaticImage
            src="../assets/img/history-01.jpg"
            alt="Imagem da sacada"
            className={st.firstImage}
            loading="lazy"
          />
          <div className={st.historyTwo}>
            <p>
              {t('JeitoDimas.ourName.1')}
              <br />
              {t('JeitoDimas.ourName.2')}
              <br />
              {t('JeitoDimas.ourName.3')}
            </p>
            <StaticImage
              src="../assets/img/history-02.jpg"
              alt="Mulher andando de bicicleta"
              className={st.historyTwoImage}
              loading="lazy"
            />
          </div>
          <StaticImage
            src="../assets/img/history-03.jpg"
            alt="Mulher em varanda frente ao mar"
            className={st.lastImage}
            loading="lazy"
          />
        </div>
        <div className={st.videoContainer} onClick={() => setModalOpen(true)}>
          <div className={st.videoContent}>
            <span>{t('JeitoDimas.watchOurManifesto')}</span>
            <img src={play} alt="Botão Play" />
          </div>
          <StaticImage
            src="../assets/img/manifest.jpg"
            alt="Bridge Cover"
            className={st.bridgeCover}
            loading="lazy"
          />
        </div>
      </section>
      <ValuesTabs />
      <section className={st.practiceWrapper}>
        <div className={st.practiceContainer}>
          <div className={st.practice}>
            <div>
              <StaticImage
                src="../assets/img/rua-mobile-02.jpg"
                width={600}
                height={433}
                alt=""
                className={st.mobile}
              />
              <StaticImage
                src="../assets/img/dseason02.jpg"
                width={573}
                height={1803}
                alt=""
                className={st.desktop}
              />
            </div>
            <div>
              <h4>
                {t('JeitoDimas.housingSolutions')
                  .split('\n')
                  .map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index <
                        t('JeitoDimas.housingSolutions').split('\n').length -
                          1 && <br />}
                    </React.Fragment>
                  ))}
                <br />
                {t('JeitoDimas.dimasWay')}
              </h4>
              <p>{t('JeitoDimas.weDevelopedALine')}</p>
              <ul>
                <li>
                  <StaticImage
                    src="../assets/img/home-design.jpg"
                    width={282}
                    height={282}
                    alt="Home Design"
                  />
                  <div className={st.info}>
                    <h4>Home design</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t('JeitoDimas.designAsASolution'),
                      }}
                    />
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../assets/img/residence-club.jpg"
                    width={282}
                    height={282}
                    alt="Residence Club"
                  />
                  <div className={st.info}>
                    <h4>Residence Club</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t('JeitoDimas.multiTower'),
                      }}
                    />
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../assets/img/smart-living.jpg"
                    width={282}
                    height={282}
                    alt="Smart Living"
                  />
                  <div className={st.info}>
                    <h4>Smart Living</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t('JeitoDimas.placeWithCentrality'),
                      }}
                    />
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../assets/img/beach-concept.jpg"
                    width={282}
                    height={282}
                    alt="Beach Concept"
                  />
                  <div className={st.info}>
                    <h4>Beach Concept</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t('JeitoDimas.beachConceptDescription'),
                      }}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className={st.blog}>
            <div>
              <div className={st.textInfo}>
                <div>
                  <h2>
                    {t('JeitoDimas.improveTheCity')}
                    <br />
                    <b>{t('JeitoDimas.dimasWay')}</b>
                  </h2>
                  <p>
                    {t('JeitoDimas.weWantToBuild')
                      .split('\n')
                      .map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          {index <
                            t('JeitoDimas.weWantToBuild').split('\n').length -
                              1 && <br />}
                        </React.Fragment>
                      ))}
                  </p>
                </div>
              </div>
              <div className="swiper-container">
                <Swiper
                  modules={[Navigation, Pagination]}
                  navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }}
                  pagination={true}
                  breakpoints={{
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 65,
                      loop: true,
                    },
                    980: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                      loop: true,
                    },
                    768: {
                      slidesPerView: 1,
                      spaceBetween: 30,
                      loop: false,
                    },
                  }}
                  className={st.slidesWrapper}
                >
                  {dimasWays.map(
                    (post: {
                      id: string
                      url: string
                      image: string
                      title: string
                      description: string
                      external: boolean
                      imageFile: {
                        childImageSharp: {
                          gatsbyImageData: IGatsbyImageData
                        } | null
                      } | null
                    }) => {
                      const image = getImage(post.imageFile)

                      return (
                        <SwiperSlide key={post.id} className={st.slide}>
                          <meta itemProp="url" content={post.url} />
                          {image ? (
                            <GatsbyImage image={image} alt={post.title} />
                          ) : (
                            <img
                              src={post.image}
                              alt={post.title}
                              width={439}
                              height={282}
                              loading="lazy"
                            />
                          )}
                          <span itemProp="publisher">{post.title}</span>
                          <p itemProp="name">{post.description}</p>
                          {post.url && post.url !== ' ' && post.url !== '' && (
                            <Link
                              to={post.url}
                              target={post.external ? '_blank' : '_self'}
                              rel={
                                post.external
                                  ? 'noopener noreferrer'
                                  : undefined
                              }
                            ></Link>
                          )}
                        </SwiperSlide>
                      )
                    }
                  )}
                </Swiper>

                {dimasWays.length > 3 && (
                  <>
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Differential />
      <Testimonials />
      {/*<WorkWithUsBanner />*/}
      <Modal
        open={modalOpen}
        close={() => setModalOpen(false)}
        className={st2.videoModal}
        clientOnly
      >
        <iframe
          src="https://www.youtube.com/embed/Rb1-eyAbws8"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </Modal>
    </>
  )
}
